
import { ref, getCurrentInstance, computed, reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
// import screenfull from 'screenfull'
import { useI18n } from 'vue-i18n'
import { resetRoute } from '@/router/index'
import { useStore } from '@/store/index.ts'
import { useTitle } from '@/utils/setWebTitle'
import { Session, Local } from '@/utils/storage'
import UserNews from '@/layout/navBars/breadcrumb/userNews.vue'
import Search from '@/layout/navBars/breadcrumb/search.vue'
export default {
  name: 'layoutBreadcrumbUser',
  components: { Search },
  setup () {
    const { t } = useI18n()
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const title = useTitle()
    const searchRef = ref()
    const state = reactive({
      isScreenfull: false,
      isShowUserNewsPopover: false,
      disabledI18n: 'zh-cn',
      disabledSize: ''
    })
    // 获取用户信息 vuex
    const getUserInfos = computed(() => {
      return store.state.userInfos.userInfos
    })
    // 获取布局配置信息
    const getThemeConfig = computed(() => {
      return store.state.themeConfig.themeConfig
    })
    // 设置分割样式
    const layoutUserFlexNum = computed(() => {
      const { layout, isClassicSplitMenu } = getThemeConfig.value
      let num
      if (layout === 'defaults' || (layout === 'classic' && !isClassicSplitMenu) || layout === 'columns') num = 1
      else num = null
      return num
    })
    // 全屏点击时
    const onScreenfullClick = () => {
      // if (!screenfull.isEnabled) {
      //   ElMessage.warning('暂不不支持全屏')
      //   return false
      // }
      // screenfull.toggle()
      // screenfull.on('change', () => {
      //   if (screenfull.isFullscreen) state.isScreenfull = true
      //   else state.isScreenfull = false
      // })
    }
    // 布局配置 icon 点击时
    const onLayoutSetingClick = () => {
      proxy.mittBus.emit('openSetingsDrawer')
    }
    // 下拉菜单点击时
    const onHandleCommandClick = (path: string) => {
      if (path === 'logOut') {
        ElMessageBox({
          closeOnClickModal: false,
          closeOnPressEscape: false,
          title: t('message.user.logOutTitle'),
          message: t('message.user.logOutMessage'),
          showCancelButton: true,
          confirmButtonText: t('message.user.logOutConfirm'),
          cancelButtonText: t('message.user.logOutCancel'),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = t('message.user.logOutExit')
              setTimeout(() => {
                done()
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 700)
            } else {
              done()
            }
          }
        })
          .then(() => {
            Session.clear() // 清除缓存/token等
            resetRoute() // 删除/重置路由
            router.push('/login')
            setTimeout(() => {
              ElMessage.success(t('message.user.logOutSuccess'))
            }, 300)
          })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          .catch(() => {})
      } else if (path === 'wareHouse') {
        window.open('https://gitee.com/lyt-top/vue-next-admin')
      } else {
        router.push(path)
      }
    }
    // 菜单搜索点击
    const onSearchClick = () => {
      searchRef.value.openSearch()
    }
    // 组件大小改变
    const onComponentSizeChange = (size: string) => {
      Local.remove('themeConfig')
      getThemeConfig.value.globalComponentSize = size
      Local.set('themeConfig', getThemeConfig.value)
      proxy.$ELEMENT.size = size
      initComponentSize()
      window.location.reload()
    }
    // 语言切换
    const onLanguageChange = (lang: string) => {
      Local.remove('themeConfig')
      getThemeConfig.value.globalI18n = lang
      Local.set('themeConfig', getThemeConfig.value)
      proxy.$i18n.locale = lang
      initI18n()
      title()
    }
    // 设置 element plus 组件的国际化
    const setI18nConfig = (locale: string) => {
      proxy.mittBus.emit('getI18nConfig', proxy.$i18n.messages[locale])
    }
    // 初始化言语国际化
    const initI18n = () => {
      switch (Local.get('themeConfig').globalI18n) {
        case 'zh-cn':
          state.disabledI18n = 'zh-cn'
          setI18nConfig('zh-cn')
          break
        case 'en':
          state.disabledI18n = 'en'
          setI18nConfig('en')
          break
        case 'zh-tw':
          state.disabledI18n = 'zh-tw'
          setI18nConfig('zh-tw')
          break
      }
    }
    // 初始化全局组件大小
    const initComponentSize = () => {
      switch (Local.get('themeConfig').globalComponentSize) {
        case '':
          state.disabledSize = ''
          break
        case 'medium':
          state.disabledSize = 'medium'
          break
        case 'small':
          state.disabledSize = 'small'
          break
        case 'mini':
          state.disabledSize = 'mini'
          break
      }
    }
    // 页面加载时
    onMounted(() => {
      if (Local.get('themeConfig')) {
        initI18n()
        initComponentSize()
      }
    })
    return {
      getUserInfos,
      onLayoutSetingClick,
      onHandleCommandClick,
      onScreenfullClick,
      onSearchClick,
      onComponentSizeChange,
      onLanguageChange,
      searchRef,
      layoutUserFlexNum,
      ...toRefs(state)
    }
  }
}
